import React from 'react';
import {
  DefaultTypeString,
  Renderer,
  TypeObject,
  TypeString,
  TypeArray,
  WEB_PROXY,
} from '@rsos/ellington';
import CopyFieldButton from './CopyFieldButton';
import CustomAccordion from './CustomAccordion';
import { StyledCustomCard } from './CustomRenderer.styles';
import CustomSafeImageRenderer from './CustomSafeImageRenderer';
import DataCardErrorBoundary from './DataCardErrorBoundary';

export const CustomCard = ({ children }) => {
  return <StyledCustomCard>{children}</StyledCustomCard>;
};

const CustomEllingtonCard = props => {
  const { children } = props;
  return <CustomCard children={children} />;
};

const CustomRenderer = props => {
  const currentAdr = props.data;
  const incidentType = props.emergencyType?.name;
  const handleZoom = (imageURL = '') => {
    props.onZoom && props.onZoom(imageURL);
  };
  return (
    <>
      {currentAdr.map(data => {
        const body = data.body;
        const displaySchema = data.display_schema;
        return (
          <DataCardErrorBoundary key={data.payload_id}>
            <Renderer
              {...props}
              data={body}
              displaySchema={displaySchema}
              enableCopyField
              customCopyFieldComponent={CopyFieldButton}
            >
              <TypeObject render={CustomEllingtonCard} root />
              <TypeArray
                format="accordion"
                render={ownProps => (
                  <CustomAccordion {...ownProps} incidentType={incidentType} />
                )}
              />
              <TypeString
                format={WEB_PROXY}
                render={ownProps => <DefaultTypeString {...ownProps} />}
              />
              <TypeString
                format="safe-image-url"
                render={props => (
                  <CustomSafeImageRenderer {...props} onZoom={handleZoom} />
                )}
              />
            </Renderer>
          </DataCardErrorBoundary>
        );
      })}
    </>
  );
};

export default React.memo(CustomRenderer);
